import ReportPage from '../../components/report-page';

export default ReportPage;
